// @flow
import type {
  FilterAction,
  FilterType,
} from 'chronos-types';

import {
  actionTypes,
} from 'chronos-actions';


export const addFilter = (
  filterValue: string | number,
  filterType: FilterType,
): FilterAction => ({
  type: actionTypes.ADD_FILTER,
  filterValue,
  filterType,
});

export const removeFilter = (
  filterValue: string | number,
  filterType: FilterType,
): FilterAction => ({
  type: actionTypes.REMOVE_FILTER,
  filterValue,
  filterType,
});

export const setFilter = (
  filterValue: Array<string>,
  filterType: FilterType,
): FilterAction => ({
  type: actionTypes.SET_FILTER,
  filterValue,
  filterType,
});

export const setFilters = (
  values: any,
): FilterAction => ({
  type: actionTypes.SET_FILTERS,
  values,
});

export const setFilterType = (
  filterType: FilterType,
): FilterAction => ({
  type: actionTypes.SET_FILTER_TYPE,
  filterType,
});

export const loadFilterOptionsRequest = ({
  filterType,
  query,
  loadedQty,
  resolve,
}): FilterAction => ({
  type: actionTypes.LOAD_FILTER_OPTIONS_REQUEST,
  filterType,
  query,
  loadedQty,
    resolve,
  });

export const fetchFilterResourcesByIdRequest = (checkFilters) => ({
  type: actionTypes.FETCH_FILTER_RESOURCES_BY_ID_REQUEST,
  checkFilters,
});
